import "react-lazy-load-image-component/src/effects/blur.css";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import "./global.css";
import React, { useEffect } from 'react'; 

function App() {
    
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('Service Worker registered with scope: ', registration.scope);
          })
          .catch((error) => {
            console.error('Service Worker registration failed: ', error);
          });
      });
    }
  }, []); 

  return <RouterProvider router={router} />;
}

export default App;
